module.exports = __webpack_public_path__ + "static/img/0541_2.1fbd317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_2.jpg
// module id = +n8t
// module chunks = 1